// extracted by mini-css-extract-plugin
export default {"ShopItemPrimaryImage":"ShopItemPrimaryImage_ShopItemPrimaryImage__vJFTm","image":"ShopItemPrimaryImage_image__6OKnW"};